import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { Color } from '../math/Color.js';
import { Vector3 } from '../math/Vector3.js';

var Face3 = /*#__PURE__*/function () {
  function Face3(a, b, c, normal, color, materialIndex) {
    _classCallCheck(this, Face3);

    this.a = a;
    this.b = b;
    this.c = c;
    this.normal = normal && normal.isVector3 ? normal : new Vector3();
    this.vertexNormals = Array.isArray(normal) ? normal : [];
    this.color = color && color.isColor ? color : new Color();
    this.vertexColors = Array.isArray(color) ? color : [];
    this.materialIndex = materialIndex !== undefined ? materialIndex : 0;
  }

  _createClass(Face3, [{
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.a = source.a;
      this.b = source.b;
      this.c = source.c;
      this.normal.copy(source.normal);
      this.color.copy(source.color);
      this.materialIndex = source.materialIndex;

      for (var i = 0, il = source.vertexNormals.length; i < il; i++) {
        this.vertexNormals[i] = source.vertexNormals[i].clone();
      }

      for (var _i = 0, _il = source.vertexColors.length; _i < _il; _i++) {
        this.vertexColors[_i] = source.vertexColors[_i].clone();
      }

      return this;
    }
  }]);

  return Face3;
}();

export { Face3 };